// extracted by mini-css-extract-plugin
export default {"body":"style_body__snQBB","routes-wrapper":"style_routes-wrapper__5padU"};